import type { ReactNode } from 'react'

import { useTranslation } from 'react-i18next'

import { Icon } from '@/components/icon'
import { Render } from '@/components/render-if'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'

interface IHeaderUltimaAtualizacaoProps {
  titulo: string
  dataUltimaAtualizacao?: number
  popover?: ReactNode
}

const formatDate = (data: Date) =>
  data.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  })

export const HeaderUltimaAtualizacao = ({ titulo, dataUltimaAtualizacao, popover }: IHeaderUltimaAtualizacaoProps) => {
  const { t } = useTranslation('common')
  const data = dataUltimaAtualizacao ? formatDate(new Date(dataUltimaAtualizacao)) : '-'
  const Comp = popover ? Popover : 'div'

  return (
    <Comp>
      <div className="flex flex-col justify-between gap-1">
        <div className="flex items-center gap-2">
          <h3 className="text-sm">{titulo}</h3>
          <Render.If condition={popover}>
            {() => (
              <PopoverTrigger className="cursor-pointer" aria-label="Mostrar informações">
                <Icon name="info" size={16} />
              </PopoverTrigger>
            )}
          </Render.If>
        </div>
        <div className="font-nunito text-muted-foreground text-xs">{t('atualizado_em', { data })}</div>
      </div>
      <Render.If condition={popover}>{(component) => <PopoverContent>{component}</PopoverContent>}</Render.If>
    </Comp>
  )
}
